export default __webpack_public_path__ + "static/media/img-proj-sell-ticket.cadbae7f.png";